<div class="edit-page">

    <div class="visitor">

        <button class="close" (click)="close()">
            <img class="cross-icon" src="icons/profile-close.svg" />
        </button>

        <span class="visitor-txt">
            Edit Name Manually
        </span>

    </div>

    <p class="form-header">
        Update devotee name
    </p>

    <!-- FIRST NAME -->

    <div class="input-wrapper">

        <label class="label">
            First Name
        </label>

        <input type="text" class="text-box-active" [(ngModel)]="firstName" placeholder="Enter first name" />

    </div>

    <!-- MIDDLE NAME -->

    <div class="input-wrapper">

        <label class="label">
            Middle Name
        </label>

        <input type="text" class="text-box-active" [(ngModel)]="middleName" placeholder="Enter middle name" />

    </div>

    <!-- LAST NAME -->

    <div class="input-wrapper">

        <label class="label">
            Last Name
        </label>

        <input type="text" class="text-box-active" [(ngModel)]="lastName" placeholder="Enter last name" />

    </div>



    <div class="action-row">

        <button class="ac-secondary-btn" (click)="close()">
            Cancel
        </button>

        <button class="primary-btn" (click)="continue()">
            Save
        </button>

    </div>

</div>